import React, { useEffect, useRef } from 'react';
import JsBarcode from 'jsbarcode';

/**
 * BARKOD OLUŞTURUCU BİLEŞENİ
 * Referans numarasından barkod oluşturur ve yazdırılabilir format sağlar
 */
function BarcodeGenerator({ 
  referenceNumber, 
  width = 2, 
  height = 100, 
  fontSize = 20,
  displayValue = true,
  format = "CODE128"
}) {
  const barcodeRef = useRef(null);

  useEffect(() => {
    if (referenceNumber && barcodeRef.current) {
      try {
        // Referans numarasını temizle (sadece alfanumerik karakterler)
        const cleanReferenceNumber = String(referenceNumber).replace(/[^A-Z0-9]/g, '');
        
        if (cleanReferenceNumber.length >= 3) {
          // JsBarcode ile barkod oluştur
          JsBarcode(barcodeRef.current, cleanReferenceNumber, {
            format: format,
            width: width,
            height: height,
            displayValue: displayValue,
            fontSize: fontSize,
            textAlign: "center",
            textPosition: "bottom",
            textMargin: 2,
            fontOptions: "bold",
            font: "monospace",
            background: "#ffffff",
            lineColor: "#000000",
            margin: 10,
            marginTop: 10,
            marginBottom: 10,
            marginLeft: 10,
            marginRight: 10
          });
          console.log('BarcodeGenerator: Barkod başarıyla oluşturuldu:', cleanReferenceNumber);
        } else {
          console.warn('BarcodeGenerator: Referans numarası çok kısa:', cleanReferenceNumber);
        }
      } catch (error) {
        console.error('BarcodeGenerator: Barkod oluşturma hatası:', error);
        // Hata durumunda canvas'ı temizle
        if (barcodeRef.current) {
          const ctx = barcodeRef.current.getContext('2d');
          ctx.clearRect(0, 0, barcodeRef.current.width, barcodeRef.current.height);
        }
      }
    }
  }, [referenceNumber, width, height, fontSize, displayValue, format]);

  if (!referenceNumber) {
    return (
      <div className="flex items-center justify-center p-4 bg-gray-100 rounded-lg">
        <span className="text-gray-500">Referans numarası bekleniyor...</span>
      </div>
    );
  }

  return (
    <div className="barcode-container flex flex-col items-center p-4 bg-white rounded-lg border">
      <canvas ref={barcodeRef} className="max-w-full"></canvas>
      <div className="mt-2 text-sm text-gray-600 font-mono">
        {referenceNumber}
      </div>
    </div>
  );
}

export default BarcodeGenerator;